import React from "react";
import styled from "styled-components";
import typography, { rhythm } from "../utils/typography"
import presets from "../utils/presets";



const H1 = styled.h1`
  color: ${props => props.light ? presets.accent : presets.dark };
  text-transform: capitalize;
  position:relative;
  margin-bottom: ${rhythm(1.5)};
  margin-top: ${rhythm(1.5)};
  :before{
    content:'';
    display:block;
    position:absolute;
    width: ${rhythm(0.5)};
    height: ${rhythm(0.05)};
    top: -${rhythm(0.5)};
    left:0;
    background-color: ${props => props.light ? presets.accent : presets.dark };
    font-size: 1rem;
    font-weight: 400;
    font-family: ${presets.mono};
  }
  :after{
    content:'';
    display:block;
    position:absolute;
    width: ${rhythm(0.5)};
    height: ${rhythm(0.05)};
    bottom: -${rhythm(0.5)};
    left:0;
    background-color: ${props => props.light ? presets.accent : presets.dark };
    font-size: 1rem;
    font-weight: 400;
    font-family: ${presets.mono};
  }
`

export default H1



// WEBPACK FOOTER //
// ./src/com/H1.js